import { assetUrl } from '@/utils/asset-url';
import { ReactComponent as WhatsNew } from '@/assets/svgs/whats-new-default.svg';
import { Button } from '@dextech-ai/dex-design-system';
import Modal from "@/dsComponents/Modal";
import useModal from "@/hooks/use-modal";
import { ModalBody, ModalFooter, ModalFooterLeft, ModalFooterRight, ModalHeader, ModalTitle } from '@dextech-ai/dex-design-system';
import { InfoOutlined } from '@dextech-ai/dex-design-system/icons';
import PropTypes from 'prop-types';
import { useEffect, useState } from "react";
import MultiClamp from 'react-multi-clamp';
import useWhatsNew from "../../hooks/use-whatsnew/index";


const Page = ({ showWhatsNew, setShowWhatsNew }) => {
	const { visible: visiblePopup, show: showPopup, hide: hidePopup } = useModal();
	const [countStep, setCountStep] = useState(1);
	const { fetch: getFeatures, accept: acceptFeatures } = useWhatsNew();
	const [dotsButton, setDotsButton] = useState([]);
	const [features, setFeatures] = useState([]);
	const [activeData, setActiveData] = useState();


	useEffect(async () => {
		if (showWhatsNew === true) {
			const [error, whatsNew] = await getFeatures();
			setCountStep(1);
			setFeatures(whatsNew.features);
			setActiveData(whatsNew.features[0]);
			showPopup();
			setShowWhatsNew(false);
			setActiveDot(0, whatsNew.features);

			let profile = JSON.parse(sessionStorage.getItem("profile"));
			profile = { ...profile, whatsNewId: whatsNew.id };
			await acceptFeatures({ id: profile.id, whatsNewId: whatsNew.id });
			sessionStorage.setItem("profile", JSON.stringify(profile));
		}
	}, [showWhatsNew]);

	function handleFeatures(count) {
		setActiveData(features[count - 1]);
		setActiveDot(count - 1, features);
	}

	const handleNext = () => {
		setCountStep(countStep + 1);
		handleFeatures(countStep + 1)
	};

	const handlePrevious = () => {
		setCountStep(countStep - 1);
		handleFeatures(countStep - 1)
	}

	const handleToggle = (key) => {
		setCountStep(key + 1);
		handleFeatures(key + 1)
	}

	const setActiveDot = (index, featuresRow) => {
		let dots = featuresRow.map(_ => 'inactive');
		dots[index] = 'active';
		setDotsButton(dots);
	}

	return (
		<Modal visible={visiblePopup} close={hidePopup} dismissClickOutsideModal={false} addClass={"card-feature__new"}>
			<ModalHeader icon={<InfoOutlined color="primary" />}>
				<ModalTitle>
					<span className="card-configure__new__header_subTitle">What's New :</span>&nbsp;<span className="card-configure__new__header_subTitle">{activeData?.heading}</span>
				</ModalTitle>
			</ModalHeader>

			<ModalBody>
				<div className="card-features__new__body_main">
					<div className="left">
						{activeData?.image === "/" ? (<WhatsNew />) : (
							<img alt="feature" className="card-features__body__left__image" src={activeData?.image} />
						)}
					</div>
					<div className="right">
						<div className="subTtitle">
							<MultiClamp clamp={2}>{activeData?.subheading}</MultiClamp>
						</div>
						<div className="content">
							{activeData?.body &&
								activeData.body.map((item, key) => (
									<div style={{ overflow: "auto" }} key={"key_" + key}>{item}</div>
								))}
						</div>
					</div>
				</div >
				<div style={{ width: 'fit-content', margin: 'auto', padding: '8px 0' }}>
					{features?.length > 1 && features.map((_item, key) => (
						<div
							className={`newfeatures-radio_class ${dotsButton[key]} ${key}`}
							key={"key_" + key}
							name="nextfeature"
							onClick={() =>
								handleToggle(key)
							}
							onKeyDown={(e) => {
								if (e.key === 'Enter') {
									handleToggle(key + 1);
								}
							}}
							tabIndex={key}
							role="button"
							aria-label="Next Feature"
							data-testid={`newfeatures-radio_${key}`}
						/>
					))}
				</div>
			</ModalBody>

			<ModalFooter>
				<ModalFooterLeft>
					<Button
						type="button"
						variant="standard-tertiary"
						fullWidth
						style={{ maxWidth: '140px' }}
						id="cancelFeaturesButton"
						onClick={() => hidePopup()}
					>Cancel</Button>
				</ModalFooterLeft>
				<ModalFooterRight>
					<div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
						{features && countStep > 1 && (
							<Button
								type="button"
								variant="standard-tertiary"
								fullWidth
								style={{ maxWidth: '140px' }}
								id="prevFeaturesButton"
								onClick={() => handlePrevious()}
							>Previous</Button>
						)}

						{features && countStep !== features.length && (
							<Button
								type="button"
								fullWidth
								style={{ maxWidth: '140px' }}
								id="nextFeaturesButton"
								onClick={() => handleNext()}
							>Next</Button>
						)}

						{countStep === features.length && (
							<Button
								fullWidth
								style={{ maxWidth: '140px' }}
								id="closeFeaturesButton"
								onClick={() => hidePopup()}
							>Ok Got it</Button>
						)}
					</div>
				</ModalFooterRight>
			</ModalFooter>
		</Modal>
	);
};

Page.propTypes = {
	setShowWhatsNew: PropTypes.func,
	showWhatsNew: PropTypes.bool
}

Page.defaultProps = {
	showWhatsNew: false
}

export default Page;
